import { render, staticRenderFns } from "./SidebarMassivelyChanges.vue?vue&type=template&id=a34ad8ac"
import script from "./SidebarMassivelyChanges.vue?vue&type=script&lang=js"
export * from "./SidebarMassivelyChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports